var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionDeleteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1802 23C11.8146 23 11.4975 22.8623 11.2289 22.5868C10.9603 22.3114 10.826 21.9861 10.826 21.6111V10.0833H10.6771C10.4852 10.0833 10.3244 10.0165 10.1947 9.88296C10.0649 9.7494 10 9.5839 10 9.38644C10 9.18899 10.0649 9.0243 10.1947 8.89235C10.3244 8.76041 10.4852 8.69444 10.6771 8.69444H13.9C13.9 8.49537 13.9649 8.32986 14.0947 8.19792C14.2244 8.06597 14.3852 8 14.5771 8H18.4229C18.6148 8 18.7756 8.06655 18.9053 8.19965C19.0351 8.33276 19.1 8.49769 19.1 8.69444H22.3229C22.5148 8.69444 22.6756 8.76122 22.8053 8.89479C22.9351 9.02836 23 9.19387 23 9.39131C23 9.58877 22.9351 9.75347 22.8053 9.8854C22.6756 10.0173 22.5148 10.0833 22.3229 10.0833H22.174V21.6111C22.174 21.9861 22.0397 22.3114 21.7711 22.5868C21.5025 22.8623 21.1854 23 20.8198 23H12.1802ZM12.1802 10.0833V21.6111H20.8198V10.0833H12.1802ZM14.1573 19.1667C14.1573 19.3634 14.2224 19.5284 14.3526 19.6615C14.4829 19.7946 14.6442 19.8611 14.8368 19.8611C15.0293 19.8611 15.1898 19.7946 15.3185 19.6615C15.4471 19.5284 15.5115 19.3634 15.5115 19.1667V12.5139C15.5115 12.3171 15.4463 12.1522 15.3161 12.0191C15.1859 11.886 15.0245 11.8194 14.832 11.8194C14.6395 11.8194 14.4789 11.886 14.3503 12.0191C14.2216 12.1522 14.1573 12.3171 14.1573 12.5139V19.1667ZM17.4885 19.1667C17.4885 19.3634 17.5537 19.5284 17.6839 19.6615C17.8141 19.7946 17.9755 19.8611 18.168 19.8611C18.3605 19.8611 18.5211 19.7946 18.6497 19.6615C18.7784 19.5284 18.8427 19.3634 18.8427 19.1667V12.5139C18.8427 12.3171 18.7776 12.1522 18.6474 12.0191C18.5171 11.886 18.3558 11.8194 18.1632 11.8194C17.9707 11.8194 17.8102 11.886 17.6815 12.0191C17.5529 12.1522 17.4885 12.3171 17.4885 12.5139V19.1667Z",
    fill: "#4A4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionDeleteImage);
export default __webpack_public_path__ + "static/media/conditionDeleteImage.a05c0540.svg";
export { ForwardRef as ReactComponent };